import { createEffect, createMemo, Match, Show, Switch } from "solid-js";
import { useHeroForm } from "../contexts/HeroFormContext"
import { getCustomChargeItems, getPriceFormatted, removeHiphen, titleCase } from "../js/itemPropsHelper";


export function CustomizationStatus() {
  const {
    color: { color },
    styleCustomizations: {
      styleCustomizations,
      handlers: { handleStyleSelection },
    }
  } = useHeroForm();

  const getDefaultStyles = () => color().options[color().selected].defaultStyles;

  const productIsCustomized = () =>
    Object.keys(styleCustomizations()).some((key) => {
      const defaultStyles = getDefaultStyles();
      return defaultStyles ? styleCustomizations()[key].selected !== defaultStyles[key] : false
    });

  return (
    <Show when={productIsCustomized()}>
      <div class="flex flex-col max-w-lg pt-2 mx-2 sm:mx-6">
        <span class="font-bold  pb-1">Customizations:</span>

        <div className="flex flex-wrap gap-1 ">
          <For each={Object.entries(styleCustomizations())}>
            {([key, val]) => {
              return (
                <Show when={getDefaultStyles()[key] !== val.selected}>
                  <div class="p-0.5 px-1 rounded-full text-xs sm:text-sm bg-canvas-light flex">
                    <span class="font-medium mr-0.5">{val.label}: </span>
                    {val.options[val.selected].label}
                    <span
                      class="ml-2 inline-block cursor-pointer "
                      onClick={() => {
                        handleStyleSelection(key, getDefaultStyles()[key]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 -960 960 960"
                        width="20"
                      >
                        <path d="m293.423-258.693-33.922-34.73L445.27-480 259.501-666.577l33.922-34.73L480-514.73l186.577-186.577 33.922 34.73L514.73-480l185.769 186.577-33.922 34.73L480-445.27 293.423-258.693Z" />
                      </svg>
                    </span>
                  </div>
                </Show>
              );
            }}
          </For>
        </div>
      </div>
    </Show>
  );
}

export function CustomizationStatusV2() {
  const {
    color: { color },
    styleCustomizations: {
      styleCustomizations,
      handlers: {
        handleStyleSelection,
        clearStyleCustomizations
      },
    },
    accentCustomizations: {
      accentSettings,
      accentFormData,
      handlers: {
        clearAccentCustomization
      }
    }
  } = useHeroForm();

  const accentChargeVariant = createMemo(() => {
    return accentSettings.options?.find(option => option.id == accentFormData.selected)?.chargeVariant;
  })

  const getDefaultStyles = () => color().options[color().selected].defaultStyles;

  const productIsCustomized = () =>
    Object.keys(styleCustomizations()).some((key) => {
      const defaultStyles = getDefaultStyles();
      return defaultStyles ? styleCustomizations()[key].selected !== defaultStyles[key] : false
    });

  const styleCharge = createMemo(() => {
    const customizationItems = getCustomChargeItems(styleCustomizations());

    return customizationItems?.length > 0
      ? getPriceFormatted(customizationItems.map(item => item.price / 100).reduce((prev, curr) => prev + curr, 0))
      : null;
  })

  const monogramInfo = () => {
    const info = []
    const selected = accentFormData.selected;

    const optionInputs = accentFormData?.option_inputs?.[selected]
    const accentSetting = accentSettings.options?.find(option => option.id == selected);

    Object.keys(optionInputs ?? {}).forEach(cKey => {
      const label = titleCase(removeHiphen(cKey));
      const value = optionInputs?.[cKey];

      info.push({
        label,
        value,
        image_url: accentSetting.fields?.[cKey]?.options?.find(option => option.id == value)?.image ?? undefined,
        hexcode: accentSetting.fields?.[cKey]?.options?.find(option => option.id == value)?.hex ?? undefined
      })
    })

    return info;
  }

  return (
    <Show when={styleCharge()}>
      <div class="flex flex-col max-w-lg mx-2 sm:mx-6 p-2 border-frame border boxy-shadow-sm bg-canvas-light">
        <span class="font-bold  pb-1">Customizations:</span>
        <div class="flex flex-col gap-1">
          <Show when={styleCharge()}>
            <div class="flex justify-between text-xs mb-0.5">
              <div class="text-sm">Style:</div>
              <div class="flex items-center">
                <Show when={styleCharge()}>
                  <div class="text-ink font-mono text-2xs px-0.5">{`+${styleCharge()}`}</div>
                </Show>
                <div
                  onClick={() => window.openCustomizationWindow(0)}
                  class="text-ink cursor-pointer underline hover:no-underline border-l border-frame px-0.5">Edit</div>
                <div
                  onClick={() => clearStyleCustomizations(color()?.options?.[color()?.selected]?.defaultStyles ?? {})}
                  class="text-ink cursor-pointer underline hover:no-underline border-l border-frame px-0.5">Clear</div>
              </div>
            </div>
            <div className="flex flex-wrap gap-1 ">
              <For each={Object.entries(styleCustomizations())}>
                {([key, val]) => {
                  return (
                    <Show when={getDefaultStyles()[key] !== val.selected}>
                      <div class="p-0.5 px-1 rounded-full text-xs bg-primary-100 border border-primary-400 flex justify-center items-center w-fit">
                        {val.options[val.selected].label}
                      </div>
                      {/* <div class="p-0.5 px-1 rounded-full text-xs sm:text-sm bg-canvas-light flex">
                      <span class="font-medium mr-0.5">{val.label}: </span>
                      {val.options[val.selected].label}
                      <span
                        class="ml-2 inline-block cursor-pointer "
                        onClick={() => {
                          handleStyleSelection(key, getDefaultStyles()[key]);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 -960 960 960"
                          width="20"
                        >
                          <path d="m293.423-258.693-33.922-34.73L445.27-480 259.501-666.577l33.922-34.73L480-514.73l186.577-186.577 33.922 34.73L514.73-480l185.769 186.577-33.922 34.73L480-445.27 293.423-258.693Z" />
                        </svg>
                      </span>
                    </div> */}
                    </Show>
                  );
                }}
              </For>
            </div>
          </Show>
          {/* <Show when={accentChargeVariant()}>
            <div class="text-xs flex justify-between">
              <div class="text-sm">Accents:</div>
              <div class="flex items-center">
                <Show when={accentChargeVariant()}>
                  <div class="text-secondary-400 font-mono text-2xs px-0.5">{`+${getPriceFormatted(accentChargeVariant().price / 100)}`}</div>
                </Show>
                <div
                  onClick={() => window.openCustomizationWindow(1)}
                  class="text-ink underline hover:no-underline border-l border-frame px-0.5">Edit</div>
                <div
                  onClick={clearAccentCustomization}
                  class="text-ink underline hover:no-underline border-l border-frame px-0.5">Clear</div>
              </div>
            </div>
            <div class="text-xs flex gap-2 bg-primary-100 border-primary-400 px-1 py-0.5 rounded-full border w-fit">
              <For each={monogramInfo()}>{(info) => (
                <div class="flex items-center gap-0.5">
                  <span class="font-bold">{info.label}: </span>
                  <Switch
                    fallback={<span>{info.value}</span>}
                  >
                    <Match when={info.image_url}>
                      <img class="h-fit" src={`${info.image_url}&width=32`} />
                    </Match>
                    <Match when={info.hexcode}>
                      <span class="w-2 h-2 rounded-full" style={`background-color: ${info.hexcode};`} />
                    </Match>
                  </Switch>
                </div>
              )}</For>
            </div>
          </Show> */}
        </div>
      </div>
    </Show>
  );
}